import * as React from 'react';
import { ITraveller } from '../../data/api/models';

export interface ICardExpired {
  customerName: string;
  policyId: string;
  policyNumber: string;
  expiredPaymentId: string;
  travellers: ITraveller[];
  icon?: any;
  tripType: string;
  updatePaymentMethod?: (policyId, expiredPaymentId, travellers, policyNumber) => any;
  cardStatus: string;
  hasRenewal?: boolean;
}

export const CardExpiredBanner = ({
                                    customerName,
                                    policyId,
                                    policyNumber,
                                    expiredPaymentId,
                                    updatePaymentMethod,
                                    icon,
                                    travellers,
                                    tripType,
                                    cardStatus,
                                    hasRenewal,
                                  }: ICardExpired) => {

  const handleUpdateCard = () => {
    updatePaymentMethod(policyId, expiredPaymentId, travellers, policyNumber)
  }
  const isAnnual = tripType === 'annual';
  let content = customerName + ', your card has expired for ' + policyNumber + ' - Click to update';
  let originalContent = true;

  switch (cardStatus) {
    case 'disabled':
      if (isAnnual) {
        if (hasRenewal) {
          content = customerName + ', it looks like your payment isn\'t going to work for ' + policyNumber + ' - Click to update';
          originalContent = false;
        }
      }
  }

  return (
    <div className={'expired-card-banner'} onClick={handleUpdateCard}>

      {!originalContent && (
        <>
          <span style={{ marginRight: '20px' }}>{icon}</span>
          <span>{content}</span>
          <span style={{ marginLeft: '20px' }}>{icon}</span>
        </>
      )}

      {originalContent && (
        <span>{content}</span>
      )}

    </div>
  )

}
